import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Alert, Toast } from "react-bootstrap";
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import { registerUser, resetRegistration } from "../../state/reducers/registration.js";
import { Scrollbars } from "react-custom-scrollbars-2";
import "../Login/Login.scss";

const Registration = () => {
  const [fullName, setFullname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationMessages, setValidationMessages] = useState({});
  const [showToast, setShowToast] = useState(false);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, error, success, message } = useSelector((state) => state.registration);

  useEffect(() => {
    if (success && message) {
      setShowToast(true);
      const timer = setTimeout(() => {
        navigate("/login");
        dispatch(resetRegistration());
      }, 3000); // Redirect after 3 seconds
      return () => clearTimeout(timer);
    } else if(message) {
      setShowToast(true)
      dispatch(resetRegistration());
    }
  }, [success, message, navigate, dispatch]);

  const handleRegister = (e) => {
    e.preventDefault();
    console.log("mun");
    const validationErrors = {};

    if (!fullName) {
      validationErrors.fullname = "Fullname is required";
    }
    if (!username) {
      validationErrors.username = "Username is required";
    }
    if (!email) {
      validationErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      validationErrors.email = "Please enter a valid email address";
    }
    if (!password) {
      validationErrors.password = "Password is required";
    }
    if (!confirmPassword) {
      validationErrors.confirmPassword = "Confirm Password is required";
    }
    if (password !== confirmPassword) {
      validationErrors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(validationErrors).length > 0) {
      setValidationMessages(validationErrors);
      return;
    }

    const payload = {
      fullName,
      username,
      email,
      password,
      role: "user"
    };

    dispatch(registerUser(payload));
  };

  return (
    <div className="page-wrapper login-page registration-page">
      <div className="left-panel">
        <img src="./images/login-img.png" alt="" className="login-img" />
      </div>
      <div className="right-panel">
        <Scrollbars autoHeight autoHeightMax={500}>
          <div className="login-wrapper">
            <div className="login-page-title text-center">
              <h2>Welcome To</h2>
              <div className="logo-wrapper justify-content-center d-flex">
                <img src="./images/ust_logo.svg" alt="" className="ust-logo me-3" />
                <h1>Code Crafter</h1>
              </div>
            </div>
            <div className="login-panel justify-content-center">
              <form className="login-form">
                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='fullName'
                      type="text"
                      label="Full Name"
                      name="fullName"
                      value={fullName}
                      id='fullName'
                      onChange={(e) => {
                        setFullname(e.target.value);
                        setValidationMessages({ ...validationMessages, fullName: "" });
                      }}
                      layoutStyle="vertical"
                      placeholder="Enter your fullname"
                      required
                      validationMsg={validationMessages.fullName}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='username'
                      type="text"
                      label="Username"
                      name="username"
                      value={username}
                      id='username'
                      onChange={(e) => {
                        setUsername(e.target.value);
                        setValidationMessages({ ...validationMessages, username: "" });
                      }}
                      layoutStyle="vertical"
                      placeholder="Enter your username"
                      required
                      validationMsg={validationMessages.username}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField
                      key='email'
                      type="email"
                      label="Email"
                      name="email"
                      value={email}
                      id='email'
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setValidationMessages({ ...validationMessages, email: "" });
                      }}
                      layoutStyle="vertical"
                      placeholder="Enter your email"
                      required
                      validationMsg={validationMessages.email}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={12}>
                    <InputField 
                      key='password' 
                      type='password' 
                      label="Password" 
                      value={password} 
                      id='password'
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setValidationMessages({ ...validationMessages, password: "" });
                      }}
                      layoutStyle="vertical"
                      placeholder="Enter your password"
                      required
                      validationMsg={validationMessages.password}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col xs={12}>
                    <InputField 
                      key='confirmPassword' 
                      type='password' 
                      label="Confirm Password" 
                      value={confirmPassword} 
                      id='confirmPassword'
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setValidationMessages({ ...validationMessages, confirmPassword: "" });
                      }}
                      layoutStyle="vertical"
                      placeholder="Re-enter your password"
                      required
                      validationMsg={validationMessages.confirmPassword}
                    />
                  </Col>
                </Row>
                {error && (
                  <Row className="mb-3">
                    <Col xs={12}>
                      <Alert className="message" variant="danger">
                        {error}
                      </Alert>
                    </Col>
                  </Row>
                )}
                <Row className="justify-content-center">
                  <Col>
                    <CustomButton 
                      label={isLoading ? "Registering..." : "Register"} 
                      type="submit"
                      disabled={isLoading}
                      onClick = {handleRegister}
                      className="login-btn" 
                    />
                  </Col>
                </Row>
              </form>
            </div>
            <div className="register mt-2">
              <div>Already a user? <Link to="/login">Login now</Link></div>
            </div>
              
            <Toast
              show={showToast}
              onClose={() => setShowToast(false)}
              delay={3000}
              autohide
              style={{
                position: "fixed",
                top: 20,
                right: 20,
                minWidth: 200
              }}
            >
              <Toast.Header>
                {success && <strong className="mr-auto">Success</strong>}
              </Toast.Header>
              <Toast.Body>{message}</Toast.Body>
            </Toast>
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default Registration;
